import { qfetch } from "@qgiv/core-js";

// -------------------------------------------------------------------------
// MARK: Utility
// -------------------------------------------------------------------------
const API_ROOT = "/api/v1/p2p";

// -------------------------------------------------------------------------
// MARK: General
// -------------------------------------------------------------------------
export const getCategories = (formId) =>
    qfetch.get(`${API_ROOT}/${formId}/categories`);

export const getClassifications = (formId) =>
    qfetch.get(`${API_ROOT}/${formId}/classifications`);

export const getP2PEventSettings = (formId) =>
    qfetch.get(`${API_ROOT}/${formId}/settings`);

export const getTeams = (formId, params) =>
    qfetch.get(`${API_ROOT}/${formId}/teams`, { params });

export const getCustomFields = (formId, params) =>
    qfetch.get(`${API_ROOT}/${formId}/customfields`, { params });

export const getProducts = (formId) =>
    qfetch.get(`${API_ROOT}/${formId}/store`);

// -------------------------------------------------------------------------
// MARK: Applied Promo Codes: BE needs this to be a GET request
// -------------------------------------------------------------------------
export const submitPromoCodes = (formId, params) =>
    qfetch.get(`${API_ROOT}/${formId}/promocodes`, { params });

// -------------------------------------------------------------------------
// MARK: Registration
// -------------------------------------------------------------------------
export const submitRegistration = (formId, data = {}) =>
    qfetch.post(`${API_ROOT}/${formId}/submit`, data);

// -------------------------------------------------------------------------
// MARK: Accounts
// -------------------------------------------------------------------------
export const submitParticipantAction = (participantAction, data = {}) =>
    qfetch.post(participantAction, data);

// MARK: Send Sharing Email
// -------------------------------------------------------------------------
export const submitSharingEmail = (path, data = {}) => {
    return qfetch.post(`/event/${path}/sendemail`, {
        ...data,
    });
};
